import React from 'react';
import PropTypes from 'prop-types';
import {HeaderLayout, LabelBar} from 'components';
import withIntl from 'lib/withIntl';
import {FmlxButton} from 'fmlx-common-ui';
import {CommonButtonLabel} from 'constants/dataEnum';
import './TipsPickupCalibration.scss';
import {Type, Variant} from 'constants/UIComponentEnum';

function TipsPickupCalibrationHeader({intl, onCloseCalibration, onAutoCalibration}) {
  return (
    <HeaderLayout className="tips-pickup-calibration-page__header page-layout-header">
      <HeaderLayout.Left>
        <div className="menu-n-title">
          <LabelBar
            className="tips-pickup-calibration-page__header__title"
            text={intl.formatMessage({id: 'tipsPickupCalibration.title'})}
          />
        </div>
      </HeaderLayout.Left>
      <HeaderLayout.Right className="tips-pickup-calibration-page__header__button-actions">
        <FmlxButton
          label={intl.formatMessage({id: CommonButtonLabel.CLOSE})}
          onClick={onCloseCalibration}
          type={Type.DANGER}
          variant={Variant.OUTLINE}
        />
        <FmlxButton
          label={intl.formatMessage({id: 'tipsPickupCalibration.buttonHeader.start'})}
          onClick={onAutoCalibration}
          type={Type.POSITIVE}
        />
      </HeaderLayout.Right>
    </HeaderLayout>
  );
}

TipsPickupCalibrationHeader.propTypes = {
  intl: PropTypes.any.isRequired,
  onCloseCalibration: PropTypes.func.isRequired,
  onAutoCalibration: PropTypes.func.isRequired,
};

export default withIntl(TipsPickupCalibrationHeader);
